import { render, staticRenderFns } from "./AnaliseAmbiental.vue?vue&type=template&id=db30697a&scoped=true&"
import script from "./AnaliseAmbiental.vue?vue&type=script&lang=js&"
export * from "./AnaliseAmbiental.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseAmbiental.vue?vue&type=style&index=0&id=db30697a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db30697a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
